import { defineMessages } from 'react-intl';

export default defineMessages({
    whatHappened: {
        id: 'fnol.bop.views.what.Describe what happened',
        defaultMessage: 'Describe what happened'
    },
    bopLossCause: {
        id: 'fnol.bop.views.what.Loss Cause',
        defaultMessage: 'Loss Cause'
    },
    selectLossCause: {
        id: 'fnol.bop.views.what.Select Loss Cause',
        defaultMessage: '--Select Loss Cause--'
    },
    incidentIndication: {
        id: 'fnol.bop.views.what.Indicate who or what caused the incident, and provide other details that would be helpful.',
        defaultMessage: 'Indicate who or what caused the incident, and provide other details that would be helpful.'
    },
    dateOfNotice: {
        id: 'fnol.bop.views.what.Date of Notice',
        defaultMessage: 'Date of Notice'
    },
    submitReport: {
        id: 'fnol.bop.views.what.Submit as report only?',
        defaultMessage: 'Submit as report only?'
    },
    detailsTitle: {
        id: 'fnol.wizard.step.bop.Details',
        defaultMessage: 'Details'
    },
    buildingTitle: {
        id: 'fnol.wizard.step.bop.Buildings',
        defaultMessage: 'Buildings'
    },
    bopWhereTitle: {
        id: 'fnol.wizard.step.bop.Where',
        defaultMessage: 'Where'
    },
    bopClaimSpecifyDetailsTitle: {
        id: 'fnol.bop.views.details.Specify the details of the selected buildings',
        defaultMessage: 'Specify the details of the selected buildings'
    },
    bopClaimDescriptionTitle: {
        id: 'fnol.bop.views.details.Description',
        defaultMessage: 'Description'
    },
    bopClaimDamageDescriptionTitle: {
        id: 'fnol.bop.views.details.Damage Description',
        defaultMessage: 'Damage Description'
    },
    bopClaimRepairEstimateTitle: {
        id: 'fnol.bop.views.details.Do you have a repair estimate?',
        defaultMessage: 'Do you have a repair estimate?'
    },
    bopClaimRepairCostTitle: {
        id: 'fnol.bop.views.details.Estimated Repair Cost',
        defaultMessage: 'Estimated Repair Cost'
    },
    bopClaimRepairTimeTitle: {
        id: 'fnol.bop.views.details.Estimated Repair Time',
        defaultMessage: 'Estimated Repair Time'
    },
    bopClaimEstimateDamageTitle: {
        id: 'fnol.bop.views.details.Estimate of Damage',
        defaultMessage: 'Estimate of Damage'
    },
    bopClaimEstimateLossTitle: {
        id: 'fnol.bop.views.details.Estimate of Loss',
        defaultMessage: 'Estimate of Loss'
    },
    bopClaimAlreadyRepairedTitle: {
        id: 'fnol.bop.views.details.Has the building already been repaired?',
        defaultMessage: 'Has the building already been repaired?'
    },
    bopClaimClassCodeTitle: {
        id: 'fnol.bop.views.details.Class Code',
        defaultMessage: 'Class Code'
    },
    bopClaimNumberofStoriesTitle: {
        id: 'fnol.bop.views.details.Number of Stories',
        defaultMessage: 'Number of Stories'
    },
    bopClaimRoofMaterialsTitle: {
        id: 'fnol.bop.views.details.Roof Covering Materials',
        defaultMessage: 'Roof Covering Materials'
    },
    bopClaimExteriorMaterialTitle: {
        id: 'fnol.bop.views.details.Exterior Wall Material',
        defaultMessage: 'Exterior Wall Material'
    },
    bopClaimOccupancyTitle: {
        id: 'fnol.bop.views.details.Type of Occupancy',
        defaultMessage: 'Type of Occupancy'
    },
    bopClaimLossAreaTitle: {
        id: 'fnol.bop.views.details.Loss Area',
        defaultMessage: 'Loss Area'
    },
    bopWizardWhat: {
        id: 'fnol.wizard.step.bop.What',
        defaultMessage: 'What'
    },
    bopBuildingAffeected: {
        id: 'fnol.bop.views.properties.Select affected buildings',
        defaultMessage: 'Select Affected Buildings'
    },
    bopBuildingSearch: {
        id: 'fnol.bop.views.properties.Search for buildings or locations',
        defaultMessage: 'Search for buildings or locations'
    },
    bopBuildingDetails: {
        id: 'fnol.bop.views.properties.Building Details',
        defaultMessage: 'Building Details'
    },
    bopBuildingNo: {
        id: 'fnol.bop.views.properties.BUILDING No.',
        defaultMessage: 'Building No.'
    },
    bopBuildingLocation: {
        id: 'fnol.bop.views.properties.Location',
        defaultMessage: 'Location'
    },
    bopBuildingLocationNo: {
        id: 'fnol.bop.views.properties.LOCATION No.',
        defaultMessage: 'Location No.'
    },
    bopSelectedBuildings: {
        id: 'fnol.bop.views.properties.Building(s) Selected',
        defaultMessage: 'Building(s) Selected'
    },
    bopCreateDraftClaim: {
        id: 'fnol.bop.config.FlowConfig.Creating draft claim...',
        defaultMessage: 'Creating draft claim...'
    },
    bopCreateDraftErrorTitle: {
        id: 'fnol.bop.config.FlowConfig.Error creating claim',
        defaultMessage: 'Error creating claim'
    },
    bopCreateDraftErrorMessage: {
        id: 'fnol.bop.config.FlowConfig.An error occurred attempting to create a claim.',
        defaultMessage: 'An error occurred attempting to create a claim.'
    },
    bopNoBuildings: {
        id: 'fnol.bop.views.properties.There are no buildings',
        defaultMessage: 'There are no buildings'
    }
});
